import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/a-mother-holding-an-infant.webp';
import financialPlanningImageMobileWebp from './images/a-mother-holding-an-infant-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-1'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>We believe in putting <WidowBlock>people first.</WidowBlock></>}
      // column content
      columnContentA={(
        <Typography disableBottomPadding>
          As a mutual company, people are our DNA. We don&#39;t have shareholders, so instead of reporting to Wall Street, we give our policyowners governance rights. And since our company belongs to them, our profits go to them in the form of dividends.<sup>4</sup> Not only is Northwestern Mutual&#39;s dividend payout larger than our two closest competitors combined,<sup>3,5</sup> we&#39;ve paid them every year since 1872. So when we do well, you do well, too.
        </Typography>
      )}
      // image props
      imageAltText='A mother holding her infant child.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
